import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const WEBCAST_PATTERN = 'brighttalk.com/webcast/'
const CONFIG_CLASS = 'jsBrightTALKEmbedConfig'
const SCRIPT_CLASS = 'jsBrightTALKEmbed'
const ELEM_CLASS = 'jsBrightTALKEmbedWrapper'
const SCRIPT_ENDPOINT = 'https://www.brighttalk.com/clients/js/player-embed/player-embed.js'

class BrightTalk extends React.Component {
  constructor(props) {
    super(props)

    const params = this.parseParamsFromUrl(props.item.link_url)

    this.state = {
      channelId: params.channelId,
      commId: params.commId
    }
  }

  componentDidMount() {
    this.appendBrightTalk()
  }

  parseParamsFromUrl = (url) => {
    const urlWithoutParams = url.split('?')[0]
    const params = urlWithoutParams.split(WEBCAST_PATTERN)[1]
    const paramValues = params ? params.split('/') : []

    return {
      channelId: paramValues[0],
      commId: paramValues[1]
    }
  }

  appendBrightTalk = () => {
    this.attachConfigurationScript()
    this.attachSourceScript()
  }

  attachSourceScript = () => {
    const script = document.createElement("script")
    script.className = SCRIPT_CLASS
    script.src = SCRIPT_ENDPOINT
    script.async = true;
    this.embedWrapper.appendChild(script)
  }

  attachConfigurationScript = () => {
    const configJson = {
      channelId: this.state.channelId,
      language: "en-US",
      commId: this.state.commId,
      displayMode: "standalone",
      height: "auto"
    }

    const config = document.createElement("script")
    config.className = CONFIG_CLASS
    config.type = "application/json"
    config.innerHTML = JSON.stringify(configJson)
    this.embedWrapper.appendChild(config)
  }

  render() {
    return (
      <div className="brighttalk-container">
        { this.state.commId && (
          <div className={ELEM_CLASS} ref={ref => this.embedWrapper = ref} />
        )}
      </div>
     )
  }
}

BrightTalk.propTypes = {
  item: PropTypes.object.isRequired
}

export default BrightTalk
